export default {
  confirmOrder: 'Confirmer la commande',
  createSuccess: 'Commande créée avec succès',
  orderPrice: 'Prix total de la commande',
  otherAction: 'Autres actions',
  orderStatus: 'Statut de la commande',
  afterSales: 'Après-vente',
  allSelect: 'Tout sélectionner',
  orderNo: 'N° de commande',
  createTime: 'Heure de création',
  productRemark: 'Informations sur la note du produit',
  productRemarkHolder:
    "Message pour l'agent d'achat, si aucune exigence d'achat spéciale, ne pas remplir.",
  orderDetail: 'Détails de la commande',
  goPay: 'Payer',
  cancelpay: 'Annuler le paiement',
  cancelPay: 'Annuler le paiement ?',
  cancelOrder: 'Annuler la commande ?',
  cancelorder: 'Annuler la commande',
  cancelOrderProduct: 'Annuler le produit ?',
  cancelorderProduct: 'Annuler le produit',
  cancelPayResultHint:
    "Après l'annulation, le paiement ne pourra pas être rétabli, veuillez sélectionner le motif d'annulation du paiement",
  cancelOrderResultHint:
    "Après l'annulation, la commande ne pourra pas être rétablie, veuillez indiquer le motif d'annulation de la commande",
  delOrder: 'Supprimer la commande',
  delOrderHint:
    "Êtes-vous sûr de vouloir supprimer la commande ? Si le produit a été remboursé, l'article ne sera pas retourné au vendeur pour un remboursement",
  cancelSuccess: 'Annulation réussie',
  delSuccess: 'Suppression réussie',
  orderBin: 'Corbeille de commandes',
  backOrder: 'Retour à ma commande',
  restoreOrder: 'Restaurer la commande',
  remark: 'Remarques',
  all: 'Tous',
  productName: 'Nom du produit',
  submitTime: 'Heure de soumission',
  orderConsult: 'Demande de commande',
  appendService: 'Service supplémentaire',
  iKnow: 'Je comprends',
  cancelReturnBag: "Annuler le retour et l'échange",
  isCancelApply: 'Êtes-vous sûr de vouloir annuler la demande ?',
  cancelBackTax: 'Annuler le complément de paiement',
  productAttr: 'Attributs du produit',
  backTaxType: 'Type de complément de paiement',
  taxPrice: 'Prix du complément de paiement',
  productBackTax: 'Complément de paiement du produit',
  freightBackTax: 'Complément de paiement du fret',
  productTaxPrice: 'Prix du complément de paiement du produit',
  freightTaxPrice: 'Prix du complément de paiement du fret',
  totalTaxPrice: 'Prix total du complément de paiement',
  productStatus: 'Statut du produit',
  isNeedTax: 'Nécessite un complément de paiement',
  yes: 'Oui',
  no: 'Non',
  iThinkAbout: 'Je vais y réfléchir',
  revokeCheckedProduct: 'Révoquer le produit sélectionné',
  taxTips1:
    "Veuillez [Effectuer le complément de paiement] ou [Annuler] dès que possible afin de ne pas affecter l'achat d'autres produits dans la commande.",
  cancelTaxTips1:
    'Si vous ne souhaitez pas effectuer le complément de paiement, nous ne pourrons pas acheter le produit qui nécessite un complément de paiement.',
  cancelTaxTips2:
    'Les produits marqués seront annulés après la révocation, et le coût du produit sera remboursé sur votre compte.',
  cancelTaxTips3:
    "Les produits non marqués continueront d'être conservés et nous continuerons à acheter pour vous.",
  cancelReason: {
    0: "Je ne veux pas l'acheter",
    1: 'Informations saisies incorrectement',
    2: 'Vendeur en rupture de stock',
    3: 'Impossible de payer',
    4: 'Autres raisons',
    5: 'Risque de marque',
  },
  hint: 'Indice',
  orderStatusEnum: {
    0: 'En attente de paiement',
    1: 'Non traité',
    2: "En cours d'examen",
    3: 'Commande transférée',
    4: 'Commande annulée',
    5: 'Complément de paiement du fret',
    6: 'Examen du contrôle des risques',
    7: 'Commande révoquée',
    8: 'Paiement en cours',
    9: 'Terminé',
  },
  returnGood: {
    name: 'Retour/Échange',
    selectType: 'Sélectionner le type',
    returnGood: 'Retour',
    returnDayTips: 'Prend généralement 7 à 15 jours',
    changeGood: 'Échange',
    changeDayTips: 'Prend généralement 7 à 20 jours',
    returnReasonEnum: {
      0: "Acheté par erreur/Je n'aime pas",
      1: 'Le vendeur a envoyé le mauvais produit ?',
      2: 'Problème de qualité du produit',
      3: 'Non expédié dans le délai convenu',
      5: 'Autres raisons',
    },
    returnReasonSelect: 'Sélectionner le motif du retour',
    returnExplain: 'Instructions de retour',
    residueReturnNumTips: 'Droits de retour de service gratuits restants ce mois-ci',
    returnTips:
      "Vérification finale du retour due au vendeur ou à la plateforme, acbuy remboursera les frais d'expédition que vous avez supportés.",
    changeTips:
      "Pour les retours ou les échanges dus à des raisons imputables au vendeur, vous devrez peut-être encore supporter une partie des frais d'expédition de l'échange.",
    returnTip4: 'Rappel amical',
    returnTip5:
      "Le service de retour et d'échange fixera un certain nombre de fois de service d'opération gratuites. (Chaque utilisateur peut demander le retour ou l'échange de marchandises sans frais de service d'opération pour la première fois chaque mois, tandis que les frais d'expédition générés par le retour ou l'échange de marchandises sont négociés entre l'agent et le vendeur et perçus par acbuy.) Frais de service de retour et d'échange acbuy : 5 Yuan/commande",
    returnTip10:
      "Si le retour ou l'échange est dû à la responsabilité de l'agent d'achat, du vendeur ou de la plateforme, le système remboursera ces 5 Yuan de frais d'opération sur votre compte de solde acbuy.",
  },
  holder: {
    selectCancelReason: 'Veuillez sélectionner le motif du retrait',
    inputOtherReason: 'Veuillez saisir le motif',
    inputSearchHint: 'Nom/N° de commande/N° de produit',
    inputCancelReason: "Veuillez saisir le motif d'annulation de la commande",
  },
  selectProducts: 'Sélectionner les produits',
  confirmStepOrder: 'Confirmer la commande',
  PayForProducts: 'Payer les produits',
  sendingPackages: 'Envoi des colis',
  submitDelivery: 'Soumettre pour la livraison',
  readAgreeText: "J'ai lu et j'accepte",
  disclaimer: 'Clause de non-responsabilité',
  orderNote:
    "Remarque : Une fois le paiement effectué, vous devrez soumettre le colis pour la livraison internationale une fois que la commande arrivera et sera stockée dans l'entrepôt.",
  goPay2: 'Paiement supplémentaire',
  backTax: 'Effectuer le complément de paiement',
  reminder: 'Rappel',
  disclaimer1: 'Description des articles interdits',
  disclaimer2: "Conditions d'utilisation",
  disclaimer3: 'Politique de retour',
  customPhotosTips:
    "Une photographie ne fournit qu'une seule exigence de détail pour photographier un article",
  backCartEdit: 'Retour à la modification du panier',
  customPhotosReminderLabel: 'Rappel amical',
  customPhotosReminder:
    "Une photo ne fournit qu'une seule exigence de détail pour prendre une photo d'un seul produit",
  packageAgreeTip1:
    '1. Les retards, dommages, pertes, taxes, confiscations et autres incertitudes liés aux services du prestataire logistique sont hors de notre contrôle, et nous ne serons pas tenus responsables des obligations qui en découlent. Cependant, nous ferons tout notre possible pour vous rappeler de bien réfléchir avant de faire un achat, vous aider à résoudre tout problème avec le prestataire logistique et vous indemniser conformément à la politique après-vente fournie par le prestataire logistique.',
  packageAgreeTip2:
    "2. Nous vous recommandons de déclarer votre colis avec précision. Si votre colis fait l'objet de contrôles aléatoires lors du dédouanement dans le pays de destination, vous devrez peut-être payer des taxes. Si vous recevez un avis d'imposition, veuillez payer les taxes en conséquence, sinon vous pourriez être confronté à des conséquences telles que le paiement de frais de retour élevés et la destruction du colis.",
  applyRefund: 'Demander un remboursement',
  refundReminder:
    "Conseils : Après avoir demandé un remboursement, l'acheteur vérifiera l'état du produit et ne pourra pas annuler la demande de remboursement avant de l'avoir vérifié.",
  inputApplyReason: 'Veuillez saisir le motif de la demande',
  orderConfirm: 'Confirmation de la commande',
  replyMsg: 'Message de réponse',
  replyMsgTips:
    "Notez les informations que vous envoyez, nous les notifierons à l'acheteur pour vérification.",
  shoppingOrder: "Commandes d'agent d'achat",
  transportOrder: 'Commandes de transfert de colis',
  choosePlatform: 'Choisir une plateforme',
  selectTargetCountry: 'Choisir le pays de destination',
  selectCountryTips:
    "Veuillez choisir/remplir votre pays de destination afin qu'acbuy puisse distinguer si l'article peut être livré ou non.",
  pleaseSelectOrder: 'Veuillez sélectionner les commandes dans la même devise pour le règlement',
  canNotStorageTip:
    'Le produit est en stockage depuis plus de 5 jours et ne peut être ni retourné ni échangé.',
  purchaseService: "Services d'achat",
  refundProgress: 'Traitement du remboursement en cours',
  returnChangeTip:
    "Remarque : Si le produit présente des problèmes de qualité mineurs (traces de colle, défauts, taches), le vendeur peut ne pas supporter les frais de retour. Dans ce cas, vous devrez supporter vous-même les frais d'expédition !",
  goodNumTip:
    "Remarque : Lorsque la quantité d'achat du même produit est supérieure ou égale à 10 pièces, afin d'améliorer l'efficacité de l'entreposage, les inspecteurs de qualité n'effectueront des inspections de qualité que sur 20 % de vos produits. Cependant, les couleurs, les styles et les tailles de tous les produits seront toujours vérifiés pour vous. Merci de votre compréhension !",
  'i18n-0000001': 'Vidéo personnalisée',
  'i18n-0000002': 'Description du service',
  'i18n-0000003':
    "Une vidéo produit de 20 à 90 secondes sera enregistrée (la durée peut varier selon le produit), offrant aux utilisateurs un service d'inspection vidéo personnalisé.",
  'i18n-0000004':
    "Note : L'activation de produits électroniques ou numériques peut annuler le service après-vente. La plateforme décline toute responsabilité.",
  'i18n-0000005': `Les liaisons nationales sont actuellement trop peu nombreuses. Il est donc recommandé de consulter la page de calcul du fret ou le panier d'achat avant d'acheter le produit afin d'éviter des frais logistiques excessifs.`,
  'i18n-0000006': 'Itinéraires de livraison vers le pays de destination : {lineNum}',
  buyAgain: 'Acheter à nouveau',
  remindShop: 'Rappeler l’expédition',
}
